export default __webpack_public_path__ + "static/media/480_private03-nl-mobile.d47197d8.png";